module.exports = __webpack_public_path__ + "static/img/tooltipInactive.ceffbfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tooltipInactive.png
// module id = 87
// module chunks = 1